/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum OpportunityStage {
  Develop = "0A - Develop",
  Validate = "0B - Validate",
  Intake = "0C - Intake",
  Craft = "1 - Craft",
  Compete = "2 - Compete",
  Contract = "3 - Contract",
  ClosedLost = "Closed Lost",
  ClosedWon = "Closed Won",
}

export const OpportunityStageDisplay: Record<OpportunityStage, string> = {
  [OpportunityStage.Develop]: "0A - Develop",
  [OpportunityStage.Validate]: "0B - Validate",
  [OpportunityStage.Intake]: "0C - Intake",
  [OpportunityStage.Craft]: "1 - Craft",
  [OpportunityStage.Compete]: "2 - Compete",
  [OpportunityStage.Contract]: "3 - Contract",
  [OpportunityStage.ClosedLost]: "Closed Lost",
  [OpportunityStage.ClosedWon]: "Closed Won",
};
